/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Keen_Robin_GlideInputs */

const en_quiet_keen_robin_glide = /** @type {(inputs: Quiet_Keen_Robin_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide empty segments`)
};

const de_quiet_keen_robin_glide = /** @type {(inputs: Quiet_Keen_Robin_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Segmente ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide empty segments" |
*
* @param {Quiet_Keen_Robin_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_keen_robin_glide = /** @type {((inputs?: Quiet_Keen_Robin_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Keen_Robin_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_keen_robin_glide(inputs)
	return de_quiet_keen_robin_glide(inputs)
});